// extracted by mini-css-extract-plugin
module.exports = {"grid-container":"HomeUltimateSolution_grid-container__eq51w","text-content":"HomeUltimateSolution_text-content__ZmseJ","image-content":"HomeUltimateSolution_image-content__SrDOw"};